import React from "react";
import { CardElement } from "@stripe/react-stripe-js";

const CARD_ELEMENT_OPTIONS = {
  hidePostalCode: true,
  style: {
    base: {
      color: "#303238",
      fontSize: "16px",
      fontFamily: "sans-serif",
      fontSmoothing: "antialiased",
      "::placeholder": {
        color: "#CFD7DF",
      },
    },
    invalid: {
      color: "#e5424d",
      ":focus": {
        color: "#303238",
      },
    },
  },
};

function CardSection() {
  const env = process.env.REACT_APP_ENV;
  if (env !== "prod") {
    return (
      <label
        style={{
          fontFamily: "GibsonSemiBd",
          fontSize: "1.4vw",
          color: "rgb(63, 68, 90)",
          marginTop: "15px",
          width: "100%",
        }}
      >
        Card details
        <div style={{ marginInline: "-173px" }}>
          <CardElement options={CARD_ELEMENT_OPTIONS} />
        </div>
      </label>
    );
  } else {
    return (
      <label
        style={{
          fontFamily: "GibsonSemiBd",
          fontSize: "1.4vw",
          color: "rgb(63, 68, 90)",
          marginTop: "15px",
          width: "100%",
        }}
      >
        Card details
        <div>
          <CardElement options={CARD_ELEMENT_OPTIONS} />
        </div>
      </label>
    );
  }
}

export default CardSection;
